import { Core } from "@faire/design-tokens";
import Checkbox from "@faire/web/slate-deprecated/Checkbox";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  title: string;
  subtitle?: string;
  checkbox?: boolean;
  isSelected: boolean;
  onClick: () => void;
  dataTestId?: string;
  showCheckbox?: boolean;
  className?: string;
  fullWidth?: boolean;
}

export const SignUpPill: React.FC<IProps> = ({
  title,
  subtitle,
  isSelected,
  onClick,
  dataTestId,
  showCheckbox = false,
  className,
  fullWidth = false,
}) => {
  return (
    <SignUpPillContainer
      onClick={onClick}
      tabIndex={0}
      role="button"
      $isSelected={isSelected}
      $fullWidth={fullWidth}
      data-test-id={dataTestId}
      type="button"
      className={className}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onClick();
          e.preventDefault();
        }
      }}
    >
      <div style={{ flex: "1" }}>
        <Typography>{title}</Typography>
        <Typography color={Core.text.subdued} variant="labelSansRegular">
          {subtitle}
        </Typography>
      </div>
      {showCheckbox ? (
        <Checkbox
          onChange={onClick}
          checked={isSelected}
          data-test-id={`check-box-${dataTestId}`}
        />
      ) : null}
    </SignUpPillContainer>
  );
};

export const SignUpPillContainer = styled.button<{
  $isSelected: boolean;
  $fullWidth: boolean;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "fit-content")};
  border-radius: 8px;
  text-align: left;
  border: 1px solid
    ${(props) => (props.$isSelected ? Core.border.default : Core.border.muted)};
  padding: ${getSpacing(20, "3x")};
  transition: all 0.3s;
  background-color: ${(props) =>
    props.$isSelected ? Core.surface.subdued : "transparent"};

  position: relative;
  @media (any-hover: hover) {
    &:hover {
      border-color: ${Core.border.default};
    }
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "232px")};
  }
`;
